/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PortfolioCurrentHoldingQueryVariables = {|
  userId?: ?string
|};
export type PortfolioCurrentHoldingQueryResponse = {|
  +userCurrentHoldings: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +stock: {|
          +id: string,
          +name: string,
          +politicianImage: ?string,
          +upcoming: boolean,
          +price: number,
          +party: {|
            +partyName: string
          |},
        |},
        +averagePrice: ?number,
        +currentHoldingsInvested: ?number,
        +diffPercentage: ?number,
      |}
    |}>
  |}
|};
export type PortfolioCurrentHoldingQuery = {|
  variables: PortfolioCurrentHoldingQueryVariables,
  response: PortfolioCurrentHoldingQueryResponse,
|};
*/


/*
query PortfolioCurrentHoldingQuery(
  $userId: String
) {
  userCurrentHoldings(userId: $userId) {
    edges {
      node {
        stock {
          id
          name
          politicianImage
          upcoming
          price
          party {
            partyName
            id
          }
        }
        averagePrice
        currentHoldingsInvested
        diffPercentage
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "politicianImage",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "upcoming",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partyName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "averagePrice",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentHoldingsInvested",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diffPercentage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioCurrentHoldingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EarningsNodeConnection",
        "kind": "LinkedField",
        "name": "userCurrentHoldings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EarningsNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EarningsNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PoliticiansNode",
                    "kind": "LinkedField",
                    "name": "stock",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartyNode",
                        "kind": "LinkedField",
                        "name": "party",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PortfolioCurrentHoldingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EarningsNodeConnection",
        "kind": "LinkedField",
        "name": "userCurrentHoldings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EarningsNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EarningsNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PoliticiansNode",
                    "kind": "LinkedField",
                    "name": "stock",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartyNode",
                        "kind": "LinkedField",
                        "name": "party",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c870acd05c281aae4dad22163a379c4c",
    "id": null,
    "metadata": {},
    "name": "PortfolioCurrentHoldingQuery",
    "operationKind": "query",
    "text": "query PortfolioCurrentHoldingQuery(\n  $userId: String\n) {\n  userCurrentHoldings(userId: $userId) {\n    edges {\n      node {\n        stock {\n          id\n          name\n          politicianImage\n          upcoming\n          price\n          party {\n            partyName\n            id\n          }\n        }\n        averagePrice\n        currentHoldingsInvested\n        diffPercentage\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f8e010bbb835ad1af3f434c528764277';

module.exports = node;
